import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=b5e77d60&scoped=true"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e77d60",
  null
  
)

export default component.exports